import { isValidBusinessObject, NodeEdgeMapper } from '@iotv/datamodel-core';
/**
 * Transitions functions enroute from NormalizedData to NodeEdgeMapper
 */
/**
 * @returns instance of NormalizedData from input of type NormalizedData
 */
export const normalToNodeEdgeMappper = (data) => {
    let nodeEdgeMapper = new NodeEdgeMapper();
    if (data) {
        Object.entries(data).forEach(([sk, pkMapped]) => {
            Object.entries(pkMapped).forEach(([pk, ob]) => isValidBusinessObject(ob) && nodeEdgeMapper.loadItem(ob));
        });
    }
    return nodeEdgeMapper;
};
/**
 * @returns ViewObject with both edges and nodes in each slot. Consumers must filter nodes or edges depending on use case
 */
export const extractViewObjectFromNodeEdgeMapper = (nodeEdgeMapper, itemIn) => {
    let possibleViewObject = { matchedPrimary: undefined, matchedRelatedByPk: [], matchedRelatedBySk: [] };
    const item = nodeEdgeMapper.getItem(itemIn);
    if (item) {
        possibleViewObject = {
            matchedPrimary: item,
            matchedRelatedByPk: [...nodeEdgeMapper.getParentEdges(item), ...nodeEdgeMapper.getParentNodes(item)],
            matchedRelatedBySk: [...nodeEdgeMapper.getChildEdges(item), ...nodeEdgeMapper.getChildNodes(item)],
        };
    }
    return possibleViewObject;
};
